import Generator from '../../Generator'
import Types from '../../../actions/Types'

export default Generator.node({
  baseType: Types.PRINT.INVENTORY_TO_FILL,
  nodeType: Generator.NODETYPE.PRINT
})



// WEBPACK FOOTER //
// ./src/reducers/root/print/inventory_to_fill.js